<template>
	<div class="cache-page">
		<div class="cache-content">
			<div v-if="stats" class="stats-container">
				<div class="stats-row">
					<div class="stats-main">
						<div class="card stats-card">
							<h5 class="card-title">Cache Details</h5>
							<table class="stats-table">
								<tbody>
									<tr>
										<th>Routed API Calls</th>
										<td>{{ stats.calls }}</td>
									</tr>
									<tr>
										<th>Flushes</th>
										<td>{{ stats.flushes }}</td>
									</tr>
									<tr>
										<th>Deletes</th>
										<td>{{ stats.deletes }}</td>
									</tr>
									<tr>
										<th>Queues</th>
										<td>{{ stats.queues }}</td>
									</tr>
									<tr>
										<th>Queue Processes</th>
										<td>{{ stats.queueProcesses }}</td>
									</tr>
									<tr>
										<th>Hits</th>
										<td>{{ stats.hits }}</td>
									</tr>
									<tr>
										<th>Queue Length</th>
										<td>{{ queueCount }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="card actions-card">
							<div class="action-row">
								<div class="input-group">
									<input
										v-model="flushUrl"
										type="text"
										placeholder="Flush a URL"
										class="form-input"
									/>
									<button class="btn btn-primary" @click="makeFlushRequest(flushUrl)">
										Flush
									</button>
								</div>
							</div>
							<div class="action-row">
								<div class="input-group">
									<input
										v-model="deleteUrl"
										type="text"
										placeholder="Delete a URL (supports *)"
										class="form-input"
									/>
									<button class="btn btn-primary" @click="makeDeleteRequest(deleteUrl)">
										Delete
									</button>
								</div>
							</div>
							<div class="action-row button-group">
								<button class="btn btn-primary" @click="log.unshift('----------------- MARK -----------------')">
									Mark
								</button>
								<button class="btn btn-primary" @click="processQueue()">
									Process Queue
								</button>
								<button class="btn btn-danger" :disabled="locked" @click="clearCache">
									Clear Cache
								</button>
							</div>
						</div>
					</div>
					<div class="stats-sidebar">
						<div class="card metric-card">
							<h5>Hit Rate</h5>
							<div class="metric-value success">{{ stats.hits }} ({{ Number(stats.hitRate).toFixed(2) }})</div>
							<div class="metric-label">Cache Efficiency</div>
						</div>
						<div class="card metric-card">
							<h5>Misses</h5>
							<div class="metric-value danger">{{ stats.misses }}</div>
							<div class="metric-label">Excluding Flush Based</div>
						</div>
						<div class="card metric-card">
							<button class="btn btn-danger" :disabled="locked" @click="clearStats">
								Reset Stats
							</button>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="loading-container">
				<div class="spinner"></div>
			</div>
			<div class="card filter-card">
				<div class="filter-row">
					<div class="filter-input">
						<input
							v-model="filterText"
							type="text"
							placeholder="Filter log entries..."
							class="form-input"
						/>
					</div>
					<div class="request-input">
						<div class="input-group">
							<input
								v-model="requestUrl"
								type="text"
								placeholder="Make a request to a URL"
								class="form-input"
							/>
							<button class="btn btn-primary" @click="makeRequest(requestUrl)">
								Go
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="card log-card" :class="{ 'fullscreen': isFullscreen }">
				<div class="log-header">
					<h5 class="card-title">Cache Log</h5>
					<button class="btn btn-primary btn-fullscreen" @click="toggleFullscreen">
						{{ isFullscreen ? 'Exit Fullscreen' : 'Fullscreen' }}
					</button>
				</div>
				<pre class="log-viewer"><span v-for="(entry, idx) in filteredLog" :key="idx" v-html="highlightHit(entry)"></span></pre>
			</div>
		</div>
	</div>
</template>

<script>
import AdminServices from '@/admin/mixins/AdminServices';

export default {
	name: 'CachePage',
	mixins: [AdminServices],
	data() {
		return {
			stats: null,
			log: [],
			interval: null,
			filterText: '',
			requestUrl: '',
			flushUrl: '',
			deleteUrl: '',
			emptyRefreshes: 0,
			queueCount: 0,
			locked: true,
			isFullscreen: false
		}
	},
	computed: {
		filteredLog() {
			if (!this.filterText) return this.log;
			const filter = this.filterText.toLowerCase();
			return this.log.filter(entry => entry.toLowerCase().includes(filter));
		}
	},
	methods: {
		getStats() {
			this._getCacheStats((result) => {
				this.stats = result;
			});
			this._getQueueCount((result) => {
				this.queueCount = result;
			});
		},
		clearCache() {
			this._clearCache((result) => {
				this.stats = result;
			});
		},
		clearStats() {
			this._clearCacheStats(() => {
				this.getStats();
			});
		},
		processQueue() {
			this._processQueue((result) => {
				this.stats = result;
			});
		},
		makeRequest(url) {
			this._getCachedUrl(url, (result) => {
				console.log(result);
				var json = JSON.stringify(result, null, 2);
				this.log.unshift(json);
			});
		},
		makeFlushRequest(url) {
			this._flushUrl(url, (result) => {
				console.log(result);
				var json = JSON.stringify(result, null, 2);
				this.log.unshift(json);
			});
		},
		makeDeleteRequest(url) {
			this._deleteUrl(url, (result) => {
				console.log(result);
				var json = JSON.stringify(result, null, 2);
				this.log.unshift(json);
			});
		},
		getLog() {
			this._getCacheLog((result) => {
				const newEntries = result.filter(entry => !this.log.includes(entry));
				if (newEntries.length === 0) {
					this.emptyRefreshes++;
					if (this.emptyRefreshes == 7) {
						this.log.unshift('----------------- AUTO MARK -----------------');
					}
				} else {
					this.emptyRefreshes = 0;
				}
				this.log = [...newEntries, ...this.log];
			});
		},
		onLoad() {
			this.getStats();
			this.getLog();
			this.interval = setInterval(() => {
				this.getStats();
				this.getLog();
			}, 3000);
		},
		toggleFullscreen() {
			this.isFullscreen = !this.isFullscreen;
		},
		highlightHit(entry) {
			return entry.replace(/\bHIT\b/g, '<span class="text-hit">HIT</span>')
			.replace(/----------------- MARK -----------------/g, '<span class="text-mark">----------------- MARK -----------------</span>')
			.replace(/----------------- AUTO MARK -----------------/g, '<span class="text-mark">----------------- AUTO MARK -----------------</span>')
			.replace(/\bMISS\b/g, '<span class="text-danger">MISS</span>')
			.replace(/\bPROCESS QUEUE\b/g, '<span class="text-process">PROCESS QUEUE</span>')
			.replace(/\bFLUSH\b/g, '<span class="text-warning">FLUSH</span>')
			.replace(/\bQUEUE\b/g, '<span class="text-queue">QUEUE</span>')
			.replace(/\bCLEARED ALL\b/g, '<span class="text-del">CLEARED ALL</span>')
			.replace(/\bCLEARED STATS\b/g, '<span class="text-success">CLEARED STATS</span>')
			.replace(/\bDELETE\b/g, '<span class="text-del">DELETE</span>')
			.replace(/\bEXCEPTION\b/g, '<span class="text-exception">EXCEPTION</span>')
			.replace(/\bSERVICE STARTED\b/g, '<span class="text-success">SERVICE STARTED</span>')
			.replace(/(https?:\/\/[^\s]+)/g, '<span class="text-info">$1</span>')
			.replace(/(.*\*.*)/g, '<span class="text-remoteinfo">$1</span>')
			.replace(/(took \d+\.?\d* ms)/g, '<span class="text-warning">$1</span>') + "<br/>";
		}
	},
	mounted() {
		this.api = this.$route.meta?.api || 'https://api.sysodev.link';
		this.onLoad();
		this.locked = this.$route.query.unlock !== 'true';
	},
	beforeUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}
}
</script>

<style scoped>
.cache-page {
	background: #232a2f;
	min-height: 100vh;
	color: #e5e5e5;
	font-family: 'Open Sans', 'Segoe UI', Arial, sans-serif;
	margin: -25px;
	padding: 25px;
	width: 100%;
	box-sizing: border-box;
	overflow-x: hidden;
	display: table;
	table-layout: fixed;
}

.cache-content {
	width: 100%;
	max-width: 100%;
}

.stats-container {
	margin-bottom: 1.5rem;
	width: 100%;
	max-width: 100%;
	overflow: hidden;
	box-sizing: border-box;
}

.stats-row {
	display: grid;
	grid-template-columns: 1fr 400px;
	gap: 1.5rem;
	margin-bottom: 1.5rem;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	overflow: hidden;
}

@media (max-width: 1200px) {
	.stats-row {
		grid-template-columns: 1fr 300px;
	}
}

@media (max-width: 1024px) {
	.stats-row {
		grid-template-columns: 1fr;
	}

	.filter-row {
		grid-template-columns: 1fr;
	}
}

.card {
	background: #263238;
	border-radius: 0.75rem;
	border: 1.5px solid #222d32;
	padding: 1.5rem;
	box-shadow: 0 4px 24px 0 rgba(0,0,0,0.18), 0 1.5px 4px 0 rgba(0,0,0,0.12);
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	min-width: 0;
	overflow: hidden;
	position: relative;
}

.card-title {
	margin: 0 0 1rem 0;
	font-size: 1.1rem;
	font-weight: 600;
	color: #dbdbdb;
	letter-spacing: 0.5px;
}

.stats-main {
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
}

.stats-card {
	margin-bottom: 1.5rem;
}

.stats-table {
	width: 100%;
	border-collapse: collapse;
}

.stats-table th {
	text-align: left;
	padding: 0.5rem 0;
	color: #f39c12;
	font-weight: 500;
	font-size: 0.9rem;
	background: transparent;
}

.stats-table td {
	text-align: right;
	padding: 0.5rem 0;
	font-weight: 600;
	color: #e5e5e5;
	background: transparent;
	font-size: 1.1rem;
}

.stats-table tr {
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.stats-table tr:last-child {
	border-bottom: none;
}

.actions-card {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	text-align: center;
	min-width: 0;
	overflow: hidden;
}

.action-row {
	width: 100%;
	min-width: 0;
}

.input-group {
	display: flex;
	gap: 0;
	width: 100%;
}

.form-input {
	flex: 1;
	padding: 0.5rem 0.75rem;
	border: 1px solid #3a4a50;
	border-radius: 4px 0 0 4px;
	background: #1e272c;
	color: #e5e5e5;
	font-size: 0.9rem;
	font-family: inherit;
	min-width: 0;
	box-sizing: border-box;
}

.form-input::placeholder {
	color: #7a8a90;
}

.form-input:focus {
	outline: none;
	border-color: #3b82f6;
}

.input-group .btn {
	border-radius: 0 4px 4px 0;
	flex-shrink: 0;
	white-space: nowrap;
}

.btn {
	padding: 0.5rem 1.25rem;
	border: none;
	border-radius: 4px;
	font-size: 0.9rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;
	font-family: inherit;
}

.btn-primary {
	background: #375a7f;
	color: white;
}

.btn-primary:hover {
	background: #2d4a68;
}

.btn-danger {
	background: #e74c3c;
	color: white;
}

.btn-danger:hover {
	background: #c0392b;
}

.btn-danger:disabled {
	background: #7a8a90;
	cursor: not-allowed;
	opacity: 0.6;
}

.button-group {
	display: flex;
	gap: 0.5rem;
	justify-content: center;
}

.stats-sidebar {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
}

.metric-card {
	text-align: center;
}

.metric-card h5 {
	margin: 0 0 1rem 0;
	font-size: 1.05rem;
	font-weight: 600;
	color: #dbdbdb;
	letter-spacing: 0.5px;
}

.metric-value {
	font-size: 2.7rem;
	font-weight: 700;
	margin-bottom: 0.5rem;
	letter-spacing: 0.5px;
}

.metric-value.success {
	color: #00bc8c;
}

.metric-value.danger {
	color: #e74c3c;
}

.metric-label {
	font-size: 0.9rem;
	color: #dedede;
}

.metric-card .btn-danger {
	width: 100%;
}

.loading-container {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 3rem;
}

.spinner {
	width: 48px;
	height: 48px;
	border: 4px solid #3a4a50;
	border-top-color: #375a7f;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

.filter-card {
	margin-bottom: 1.5rem;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
}

.filter-row {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 1rem;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	min-width: 0;
	overflow: hidden;
}

.filter-input,
.request-input {
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
}

.filter-input input,
.request-input input {
	width: 100%;
	padding: 0.5rem 0.75rem;
	border: 1px solid #3a4a50;
	border-radius: 4px;
	background: #1e272c;
	color: #e5e5e5;
	font-size: 0.9rem;
	font-family: inherit;
	box-sizing: border-box;
}

.filter-input input::placeholder,
.request-input input::placeholder {
	color: #7a8a90;
}

.filter-input input:focus,
.request-input input:focus {
	outline: none;
	border-color: #375a7f;
}

.request-input .input-group {
	width: 100%;
}

.request-input .form-input {
	border-radius: 4px 0 0 4px;
}

.log-card {
	background: #181a1b;
	color: #e5e5e5;
	border: 1.5px solid #222d32;
	width: 100%;
	max-width: 100%;
	min-width: 0;
	overflow: auto;
	position: relative;
	transition: all 0.3s ease;
}

.log-card.fullscreen {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100vw;
	height: 100vh;
	max-width: 100vw;
	margin: 0;
	border-radius: 0;
	z-index: 9999;
}

.log-card.fullscreen .log-viewer {
	max-height: calc(100vh - 100px);
}

.log-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
}

.log-header .card-title {
	margin: 0;
}

.btn-fullscreen {
	padding: 0.4rem 1rem;
	font-size: 0.85rem;
}

.log-viewer {
	background: #181a1b;
	color: #ffffff;
	padding: 1rem;
	margin: 0;
	font-family: 'Courier New', Courier, monospace;
	font-size: 0.85rem;
	line-height: 1.6;
	max-height: 800px;
	overflow: auto;
	white-space: pre;
}

@media (max-width: 1024px) {
	.stats-row {
		grid-template-columns: 1fr;
	}

	.filter-row {
		grid-template-columns: 1fr;
	}
}
</style>

<style>
.text-info {
	color: #00a2ff !important;
}

.text-mark {
	padding-top: 10px;
	color: #00a2ff !important;
	padding-bottom: 10px;
	display: block;
	text-align: center;
	background: repeating-linear-gradient(
		135deg,
		#232a2f,
		#232a2f 10px,
		#263238 10px,
		#263238 20px
	);
	margin-top: 5px;
	margin-bottom: 5px;
}

.text-success, .text-hit {
	color: #00ff0d !important;
	font-weight: bold;
}

.text-danger {
	color: #e74c3c !important;
	font-weight: bold;
}

.text-del {
	color: #ff0000 !important;
	font-weight: bold;
}

.text-exception {
	color: #ff0000 !important;
	font-weight: bold;
	animation: flash 1s linear 10;
}

@keyframes flash {
	0%, 100% { opacity: 1; }
	50% { opacity: 0.2; }
}

.text-warning {
	color: #f39c12 !important;
	font-weight: bold;
}

.text-queue {
	color: #edc917 !important;
	font-weight: bold;
}

.text-process {
	color: #00ff0d !important;
	font-weight: bold;
}

.text-remoteinfo {
	color: #bfbfbf79 !important;
}
</style>
